export default "__VITE_ASSET__BhJXGn$S__"